module.exports = __webpack_public_path__ + "static/media/jason-profile-portrait.21cfeb2f.png";